import { Box } from '@mui/material';
import AliceCarousel from 'react-alice-carousel';
import "react-alice-carousel/lib/alice-carousel.css";
import './home.css';
import { Popup } from "./Popup";
import { useState } from "react";


const HomeSlider = (props) => {
    const [open, setOpen] = useState(false);

    const datalist = [{
        path :'images/shariq.jp',
        data : 'shariq'


    },
    {     path : 'images/deepti_1.jp',
          data : 'deepti'

    },
    {
        path : 'images/rukesh_1.jp',
        data : 'rukesh'
    }
];
    return (
        
        <div className='homeslider__container'>
            
           <Box style={{background:'#F1F1F1',width:'100vw',maxWidth:'100%',height:'100vh',maxheight:'100%'}}>
            <div  className="iot__box">
                <div  className="iot__one">
                   
                    <p className='mob_app_head' >
                        Mobile App with Bluetooth & Wifi
                    </p>
                    <div className='slider__para' >
                        Untouched mobile app that you can install on your Android or iOS device to keep
                        up to date on both battery and liquid levels wherever you are. You can simply manage because it notify you.
                    </div>
                    {/* <p className='how_head'>
                        How does it work?
                    </p>
                    <div >
                        <p style={{fontFamily:'Quicksand'}}><img id='check' src="images/check.png" alt="" />&nbsp;&nbsp;&nbsp;Install this software on your smartphone.</p> 
                        <p style={{fontFamily:'Quicksand'}}><img id='check' src="images/check.png" alt="" />&nbsp;&nbsp;&nbsp;Switch on the wifi or Bluetooth of the machine.</p> 
                        <p style={{fontFamily:'Quicksand'}}><img id='check' src="images/check.png" alt="" />&nbsp;Connect to the wifi router from which the phone is connected.</p> 
                        <p style={{fontFamily:'Quicksand'}}><img id='check' src="images/check.png" alt="" />&nbsp;Then connect your phone with the machine & sync the data.</p>  
                    </div> */}
                    
                </div>
                
                <div style={{}} className="iot__two">
                 
                        <img id="hand__img" src="/images/home_img/hand.png" alt="image" />
                   
                </div>  
            </div>
            {/* my buttons */}
                        <div className="home__app__download"> 
                            <p style={{fontFamily:'Quicksand',fontSize:'0.9rem'}}>Discover Our App</p>
                                <div className="f__app">
                                    <div className="play__button">
                                    <a href="https://play.google.com/store/apps/details?id=co.soaron.untouched_flutter">
                                        <button style={{cursor:'pointer'} } >
                                            <div className="play__bt">
                                            <div className="img__store">
                                                <img id='play' style={{width:'1.5em',height:'1.5em',marginTop:4}} src="/images/app-icon/play.png" alt="play" />
                                            </div>
                                            <div className="theo__store">
                                                <div>Available on</div>
                                                <div><b>Google Play</b></div>
                                            </div>
                                            </div>
                                        </button>
                                        </a>  
                                    </div>
                                    
                                    <div className="app__button">
                                    
                                        <button style={{cursor:'pointer'}} onClick={() => setOpen(true)}>
                                        
                                            <div className="app__bt">
                                            <div className="img__store">    
                                                <img id='apple__img'  style={{width:'1.5em',height:'1.5em',marginTop:4}} src="/images/app-icon/apple.png" alt="apple" />
                                            </div>
                                            <div  className="theo__store">
                                                <div>Download on the</div>
                                                <div style={{marginLeft:-20}}><b>App Store</b></div>
                                            </div>
                                            </div>

                                        </button>
                                        {open ? <Popup text="Coming Soon" closePopup={() => setOpen(false)} /> : null}
                                        </div>
                                </div>
                        </div>   
           </Box>
           </div>
     );
}
 
export default HomeSlider;